import React from "react";
import { Box, Container, Typography, Avatar } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";

const testimonials = [
    {
        id: 1,
        name: "Sarah Chen",
        role: "Sr. Technical Recruiter",
        company: "TechStaff Pro",
        quote:
            "Benchsales transformed our recruiting process. We're now placing consultants 3x faster than before.",
        initials: "SC",
    },
    {
        id: 2,
        name: "Michael Rodriguez",
        role: "Staffing Manager",
        company: "Apex Consulting",
        quote:
            "Finally found a platform that understands bench sales. The candidate quality is exceptional.",
        initials: "MR",
    },
    {
        id: 3,
        name: "Priya Sharma",
        role: "Full Stack Developer",
        company: "Independent Consultant",
        quote:
            "As a consultant, I love how easy it is to connect with recruiters. Landed my dream project within a week!",
        initials: "PS",
    },
    {
        id: 4,
        name: "James Wilson",
        role: "Talent Acquisition Lead",
        company: "Global Systems",
        quote:
            "The speed and accuracy of the matches are unmatched. It's become an essential tool for our hiring strategy.",
        initials: "JW",
    },
];

const Testimonials = () => {
    return (
        <Box
            sx={{
                py: { xs: 2, md: 3 },
                backgroundColor: "#F9FBFF",
                fontFamily: "'Poppins', sans-serif",
                overflow: "hidden", // Prevent horizontal scrollbar
            }}
        >
            <Container maxWidth="xl">
                {/* Header Section */}
                <Box sx={{ textAlign: "center", mb: 8 }} data-aos="fade-up">
                    <Box
                        sx={{
                            display: "inline-block",
                            px: 2,
                            py: 0.5,
                            borderRadius: "50px",
                            backgroundColor: "rgba(255, 107, 0, 0.1)", // Light orange bg
                            mb: 2,
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#FF6B00",
                                fontWeight: 600,
                                fontSize: "14px",
                                fontFamily: "'Poppins', sans-serif",
                            }}
                        >
                            Testimonials
                        </Typography>
                    </Box>
                    <Typography
                        variant="h2"
                        sx={{
                            fontWeight: 700,
                            color: "#0B1121",
                            fontSize: { xs: "32px", md: "48px" },
                            mb: 2,
                            fontFamily: "'Poppins', sans-serif",
                        }}
                    >
                        Trusted by Industry Leaders
                    </Typography>
                    <Typography
                        sx={{
                            color: "#64748B",
                            fontSize: { xs: "16px", md: "18px" },
                            maxWidth: "600px",
                            mx: "auto",
                            fontFamily: "'Poppins', sans-serif",
                        }}
                    >
                        See what recruiters and job seekers are saying about Benchsales.
                    </Typography>
                </Box>
            </Container>

            {/* Auto-Scrolling Marquee */}
            <Box
                data-aos="fade-up"
                data-aos-delay="200"
                sx={{
                    display: "flex",
                    overflow: "hidden",
                    width: "100%",
                    maskImage:
                        "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
                    WebkitMaskImage:
                        "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        gap: 4,
                        width: "max-content",
                        animation: "scroll 40s linear infinite",
                        py: 2,
                        px: 2,
                        "&:hover": {
                            animationPlayState: "paused",
                        },
                    }}
                >
                    {/* Tripled list for smooth seamless loop on wide screens */}
                    {[...testimonials, ...testimonials, ...testimonials].map(
                        (testimonial, index) => (
                            <Box
                                key={`${testimonial.id}-${index}`}
                                sx={{
                                    width: "400px", // Fixed width for consistent cards
                                    p: 4,
                                    backgroundColor: "#FFFFFF",
                                    borderRadius: "24px",
                                    border: "1px solid #E2E8F0",
                                    transition: "all 0.3s ease",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    flexShrink: 0,
                                    "&:hover": {
                                        transform: "translateY(-5px)",
                                        boxShadow: "0 20px 40px rgba(0,0,0,0.05)",
                                        borderColor: "transparent",
                                    },
                                }}
                            >
                                <Box>
                                    {/* Stars */}
                                    <Box sx={{ display: "flex", gap: 0.5, mb: 3 }}>
                                        {[...Array(5)].map((_, i) => (
                                            <StarIcon
                                                key={i}
                                                sx={{ color: "#FF6B00", fontSize: "20px" }}
                                            />
                                        ))}
                                    </Box>

                                    {/* Quote */}
                                    <Typography
                                        sx={{
                                            color: "#334155",
                                            fontSize: "16px",
                                            lineHeight: 1.8,
                                            fontFamily: "'Poppins', sans-serif",
                                            mb: 4,
                                            fontStyle: "italic",
                                        }}
                                    >
                                        "{testimonial.quote}"
                                    </Typography>
                                </Box>

                                {/* Author Profile */}
                                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                    <Avatar
                                        sx={{
                                            bgcolor: "rgba(255, 107, 0, 0.1)",
                                            color: "#FF6B00",
                                            fontFamily: "'Poppins', sans-serif",
                                            fontWeight: 600,
                                        }}
                                    >
                                        {testimonial.initials}
                                    </Avatar>
                                    <Box>
                                        <Typography
                                            sx={{
                                                fontWeight: 700,
                                                color: "#0B1121",
                                                fontSize: "16px",
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            {testimonial.name}
                                        </Typography>
                                        <Typography
                                            sx={{
                                                color: "#64748B",
                                                fontSize: "14px",
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            {testimonial.role} · {testimonial.company}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        )
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default Testimonials;
